import React from "react";
import { Button, Spinner } from "reactstrap";
import { useUserPermissions } from "../../utils/hooks/useUserPermissions";

export default function ButtonSpinner(props) {
  const { canCreate, canUpdate } = useUserPermissions();

  const {
    isLoading,
    title,
    onClick,
    isDisabled = false,
    size = 80,
    action = "C",
    marginLeft = 0,
    className = "waves-effect waves-light",
  } = props;
  const checkCanActions = () => {
    if (canCreate() && action === "C") return true;
    if (canUpdate() && action === "U") return true;
    return false;
  };

  /**
   action
   C = create
   U = update
   */

  return (
    <>
      {checkCanActions() && (
        <Button
          color={isLoading ? "secondary" : "success"}
          className={className}
          style={{ width: isLoading ? "auto" : size, marginLeft }}
          disabled={isLoading || isDisabled}
          onClick={onClick}
          type="submit"
        >
          {isLoading ? <Spinner size="sm" /> : null}
          <span> {`  ${title}`}</span>
        </Button>
      )}
    </>
  );
}
